export default {
  default: () => import("/var/www/cert/certification-platform-frontend/layouts/default.vue"),
  maintenance: () => import("/var/www/cert/certification-platform-frontend/layouts/maintenance.vue"),
  "server-rendered": () => import("/var/www/cert/certification-platform-frontend/layouts/server-rendered.vue")
}